<app-dialog-base [showLoadingSpinner]="uiState() === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title data-testid="charity-registration-url-dialog-title">Edit Link for Charities to Join the Fundraiser</span>

  <ng-container dialog-content>
  <form>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Link for Charities to Join the Fundraiser</mat-label>
      <input matInput data-testid="charity-registration-url-input" [formControl]="urlControl" placeholder="https://...">
      @if ((urlControl.dirty || urlControl.touched) && urlControl.errors) {
        <mat-error data-testid="charity-registration-url-error-message">
          Please enter a valid URL (starting with https://)
        </mat-error>
      }
    </mat-form-field>
    <p class="hint-text">Optional link to the form charities and nonprofits use to ask to join the fundraiser. It appears as a "Register your association" button on the landing page; leave empty to hide it.</p>
  </form>
  </ng-container>

  <ng-container actions>
    <button mat-button class="btn-success" data-testid="charity-registration-url-submit-button" (click)="submit()">Submit</button>
  </ng-container>
</app-dialog-base>
